
<template>
  <div class="dsf-login-user">
    <div class="login-box-info">
      <el-input
        v-model.trim="username"
        :disabled="$attrs.loading"
        :placeholder="$attrs.userNamePlaceholder"
        size="medium"
        prefix-icon="el-icon-user-solid"
      >
      </el-input>
    </div>
    <div class="login-box-info">
      <el-input
        v-model.trim="password"
        :disabled="$attrs.loading"
        type="password"
        :placeholder="$attrs.passwordPlaceholder"
        size="medium"
        prefix-icon="el-icon-s-goods"
      />
    </div>
    <div
      class="login-box-info login-code"
      v-if="$attrs.isShowCode"
    >
      <el-input
        v-model.trim="code"
        :disabled="$attrs.loading"
        type="text"
        :placeholder="$attrs.codePlaceholder"
        size="medium"
        prefix-icon="iconfont icon-yanzhengma1"
      />
      <img
        class="img-code"
        :src="$attrs.codeUrl"
        @click="$emit('updateCodeUrl')"
      />
    </div>
    <div class="login-box-info login-password">
      <el-checkbox v-model="remember">记住密码</el-checkbox>
      <div
        class="login-box-forgot-password"
        v-if="$attrs.isForgotPassword"
      >
        <span @click="$emit('toForgotPassword')">忘记密码?</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loginUser',
  created() {
    this.rememberToken = dsf.storage.local.get('rememberToken')
    if (_.isObject(this.rememberToken)) {
      let u = Object.keys(this.rememberToken)[0]
      let p = Object.values(this.rememberToken)[0]
      this.username = u
      this.password = p
      this.oldPsd = p
      this.remember = true
    }
  },
  data() {
    return {
      username: '',
      password: '',
      oldPsd: '',
      remember: false,
      code: '',
    }
  },
  methods: {
    validateFiled() {
      this.username = _.trim(this.username)
      this.password = _.trim(this.password)
      this.code = _.trim(this.code)
      if (this.username === '') {
        dsf.layer.message('账号不能为空！', false)
        return false
      }
      if (this.password === '') {
        dsf.layer.message('密码不能为空！', false)
        return false
      }
      if (this.code === '' && this.$attrs.isShowCode) {
        dsf.layer.message('验证码不能为空！', false)
        return false
      }
      return true
    },
    getLoginFileds() {
      let { username: userName, password, remember, oldPsd } = this
      return {
        userName,
        password: dsf.md5(dsf.md5(password)),
        remember,
        rememberToken: remember ? dsf.md5(dsf.md5(oldPsd)) : '',
        code: this.code || 'good',
      }
    },
    handleResetPwdCode() {
      this.code = ''
      this.password = ''
    },
    handleClearCode() {
      this.code = ''
    },
  },
}
</script>
